import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["tabindex"]
const _hoisted_2 = {
  key: 0,
  class: "base-select__label"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "base-input__error-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "base-select",
    tabindex: _ctx.tabindex,
    onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.open = false))
  }, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["base-select__selected", {
        open: _ctx.open,
        'base-select__selected--error': _ctx.getErrors.length,
        'base-select_disabled': !_ctx.getErrors.length && _ctx.disabled,
      }]),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleSelect && _ctx.toggleSelect(...args)))
    }, _toDisplayString(_ctx.selected), 3),
    _createElementVNode("div", {
      class: _normalizeClass(["base-select__items", { selectHide: !_ctx.open }])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, i) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "base-select__item",
          key: i,
          onClick: ($event: any) => (_ctx.selectItem(option))
        }, _toDisplayString(option[_ctx.optionName]), 9, _hoisted_3))
      }), 128))
    ], 2),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getErrors, (error) => {
      return (_openBlock(), _createElementBlock("div", {
        key: error.type
      }, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(error.text), 1)
      ]))
    }), 128))
  ], 40, _hoisted_1))
}